import { Button, Form, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { getPrices } from '../../services/pricing.service';
import PricingOptionAdd from './components/PricingOptionAdd';
// import PricingOptionsSearch from './components/PricingOptionsSearch';
import PricingOptionsTable from './components/PricingOptionsTable';
const PricingOptions = () => {
  const [coursePrices, setCoursePrices] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((pageNo - 1) * pageSize);
  const [fetching, setFetching] = useState(false);
  const [searchFilter, setSearchFilters] = useState({});
  const [visibleAddModal, setVisibleAddModel] = useState(false);
  const [visibleEditModal, setVisibleEditModel] = useState(false);
  const [currentPriceOption, setCurrentPriceOption] = useState(null);
  const [isPricingModalVisible, setIsPricingModalVisible] = useState(
    false
  );
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  useEffect(() => {
    fetchPricingOptions();
  }, [pageNo, pageSize, searchFilter]);

  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
    setSearchFilters({});
    setOffset(0);
    setPageNo(1);
  };
  const onFinish = (values) => {
    setPageNo(1);
    setSearchFilters(values);
  };

  const fetchPricingOptions = () => {
    setFetching(false);
    getPrices(pageNo, pageSize, searchFilter)
      .then((response) => {
        const data = response.data;
        setFetching(false);
        setTotalCount(data?.totalCount);
        setCoursePrices(data.paginatedList);
      })
      .catch((error) => {
        setFetching(false);
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  const onPaginationChange = (data) => {
    setPageNo(data.current);
    setPageSize(data.pageSize);
    setOffset(data.current * data.pageSize - data.pageSize);
  };

  const onPriceClick = (value) => {
    setCurrentPriceOption(value);
    showModal();
  };

  const showModal = () => {
    setIsPricingModalVisible(true);
  };

  const renderPricePoints = (pricePoints) => {
    return pricePoints?.map((point, index) => (
      <ul key={index}>
        <b>Price {index + 1}</b>
        <div>. Number of students: {point?.number}</div>
        <div>. Discount: {point?.discountValue}</div>
        <div>. Type: {point?.type}</div>
        <br />
      </ul>
    ));
  };

  const rederCountryWisePrice = (countryWisePrice) => {
    return countryWisePrice.map((price, index) => (
      <ul key={index}>
        <div>
          <b>{price.country}</b>: {price.currency} {price.amount}{' '}
          {price?.discountValue ? (
            <span>Deposit {price.discountValue}</span>
          ) : (
            ''
          )}
        </div>
      </ul>
    ));
  };

  return (
    <div>
      {/* <div>
        <section>
          <PricingOptionsSearch
            onFinish={onFinish}
            onReset={onReset}></PricingOptionsSearch>
        </section>
      </div> */}
      <div>
        <section>
          <Button type="ghost" onClick={() => setVisibleAddModel(true)}>
            Add
          </Button>

          <PricingOptionAdd
            isOpen={visibleAddModal}
            toggle={() => setVisibleAddModel(false)}
            setStatus={setStatus}
            status={status}
          />
        </section>
      </div>
      <div>
        <section>
          <PricingOptionsTable
            data={coursePrices}
            onPaginationChange={onPaginationChange}
            current={pageNo}
            totalCount={totalCount}
            fetching={fetching}
            offset={offset}
            onPriceClick={onPriceClick}
          />
        </section>
      </div>
      <Modal
        title="Pricing Option Details"
        visible={isPricingModalVisible}
        onCancel={() => setIsPricingModalVisible(false)}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => setIsPricingModalVisible(false)}>
            Ok
          </Button>
        ]}>
        <div>
          <span>
            <b>Total: </b>
          </span>
          <span>
            {currentPriceOption?.currency} {currentPriceOption?.total}
          </span>
        </div>
        <div>
          <span>
            <b>Type/Tag: </b>
          </span>
          <span>{currentPriceOption?.type}</span>
        </div>

        <div>
          <span>
            <b>Deposit: </b>
          </span>
          <span>
            {currentPriceOption?.deposit?.value}{' '}
            {currentPriceOption?.deposit?.type == 'percent'
              ? '%'
              : currentPriceOption?.currency}
          </span>
        </div>
        <div>
          <span>
            <b>Localised For All Countries: </b>
          </span>
          <span>
            {currentPriceOption?.localiseForAllCountries ? 'Yes' : 'No'}
          </span>
        </div>
        <div>
          <span>
            <b>Discount Enabled: </b>
          </span>
          <span>{currentPriceOption?.discountEnabled ? 'Yes' : 'No'}</span>
        </div>
        <div>
          <span>
            <b>Credits Enabled: </b>
          </span>
          <span>{currentPriceOption?.creditsEnabled ? 'Yes' : 'No'}</span>
        </div>
        <div>
          <span>
            <b>Country Wise Price: </b>
          </span>
          <span>
            {currentPriceOption?.countryWisePrice &&
              rederCountryWisePrice(currentPriceOption?.countryWisePrice)}
          </span>
        </div>
        <div>
          <b>Price points:</b>
        </div>
        <li>{renderPricePoints(currentPriceOption?.pricePoints)}</li>
      </Modal>
    </div>
  );
};

export default PricingOptions;
